var map = {
	"./Domestic-white.svg": 54067,
	"./Domestic.svg": 99283,
	"./avatar.jpg": 88084,
	"./avatar.png": 75536,
	"./background.jpg": 55671,
	"./cauliflower_logo_web.png": 22001,
	"./commercial-white.svg": 8753,
	"./commercial.svg": 83597,
	"./custom-select.png": 21773,
	"./delivery-man-black.svg": 59418,
	"./delivery-man.svg": 2672,
	"./delivery-truck.svg": 59837,
	"./delivery-truk-black.svg": 87440,
	"./error-bg.jpg": 9069,
	"./loder.png": 63527,
	"./login-rectangle.png": 95596,
	"./login.jpg": 57000,
	"./no_logo.png": 9670,
	"./ns.png": 26626,
	"./ns2.png": 45482,
	"./profile.png": 45572,
	"./stock-book-logo.svg": 41169,
	"./stockbook-imacMockup.png": 4558,
	"./whatsapp.svg": 83465
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;